import {
    ContentResponse,
    ContentsBannerRequest,
    ContentsBannerResponse,
    ContentsDetailRequest,
    ContentsParams,
    ContentSummary,
    RecommendedContentsResponse,
    SuggestKeywordResponse,
} from '$share/types/insurance/contents'
import {authInstance, externalInstance} from '$utils/api'
import {createTanstackQuery} from '$utils/createQuery'

export const getRecommendedContentsQuery = createTanstackQuery<RecommendedContentsResponse[], ContentsParams>(
    (params) => ({
        url: '/insurance/contents/recommended',
        method: 'GET',
        fetcher: authInstance,
        params,
    }),
)

export const getContentsSummaryQuery = createTanstackQuery<ContentSummary[]>(() => ({
    url: '/insurance/contents/summary',
    method: 'GET',
    fetcher: externalInstance,
}))

export const getContentQuery = createTanstackQuery<ContentResponse, ContentsDetailRequest>((params) => ({
    url: `/insurance/contents/detail`,
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getContentsQuery = createTanstackQuery<ContentResponse[], ContentsParams>((params) => ({
    url: '/insurance/contents',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getContentsBannerQuery = createTanstackQuery<ContentsBannerResponse, ContentsBannerRequest>((params) => ({
    url: `/insurance/contents/banner`,
    method: 'GET',
    fetcher: authInstance,
    params,
}))

export const getSuggestKeywordsQuery = createTanstackQuery<SuggestKeywordResponse>(() => ({
    url: '/insurance/contents/suggestKeywords',
    method: 'GET',
    fetcher: externalInstance,
}))
